export type LabelValueObject = {
  label: string;
  value: number;
};
export enum PollResultKeys {
  buyside = 'Buyside',
  retail = 'Independent'
}
export type CombinedMonthlyResults = {
  name: string;
  [PollResultKeys.buyside]?: string;
  [PollResultKeys.retail]?: string;
};
export type CombinedMonthlyResultsContainer = { [key: string]: CombinedMonthlyResults };

export const combineAndFormatPollResults = (
  buysideData: LabelValueObject[],
  retailData: LabelValueObject[]
): CombinedMonthlyResultsContainer => {
  const combinedRes = buysideData.reduce((acc, data) => {
    acc[data.label] = { name: data.label, [PollResultKeys.buyside]: data.value.toFixed(1) };
    return acc;
  }, {} as { [key: string]: CombinedMonthlyResults });

  retailData.forEach(data => {
    if (!combinedRes.hasOwnProperty(data.label)) combinedRes[data.label] = { name: data.label };
    combinedRes[data.label][PollResultKeys.retail] = data.value.toFixed(1);
  });

  return combinedRes;
};
